import { IImageValue } from './interfaces';

export const isArrayOfIImageValues = (value: unknown): value is IImageValue[] => {
  if (!Array.isArray(value)) {
    return false;
  }

  return value.every(
    (item) =>
      item !== null &&
      typeof item === 'object' &&
      'id' in item &&
      'name' in item &&
      'size' in item &&
      'preview' in item &&
      typeof item.id === 'string' &&
      typeof item.name === 'string' &&
      typeof item.size === 'number' &&
      typeof item.preview === 'string'
  );
};
